<template>
    <div class="content-wrapper intro-choose">
      <div class="d-flex align-items-center full-height justify-content-center text-center">
        <div class="row">
          <div class="col-12 mb-5">
            <h1 class="general-title choose-title mb-3">Passoni Configurator</h1>
            <p class="choose-text">
                The Passoni knowledge hub is the definitive resource for information on all aspects of our approach to bike building. <br>
                We strive to inform, educate and inspire the cycling community and the hub is one small way of imparting the years of experience and knowledge we have ascertained.
            </p>
          </div>
          <div class="col-md-6 mb-5 mb-md-0 with-divider">
            <h2 class="general-title choose-subtitle">Do you know which Passoni to choose?</h2>
            <p>Configure your Passoni as you whish.</p>
            <button class="btn btn-outline-primary mt-4" v-on:click="$emit('skip-questionnaire')">Start configuration</button>
          </div>
          <div class="col-md-6">
            <h2 class="general-title choose-subtitle">Or fill out the questionnaire.</h2>
            <p>We'll help you choose the Passoni that's right for you.</p>
            <button class="btn btn-outline-primary mt-4" v-on:click="$emit('go-next')">Go to questionnaire</button>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "intro-choose",
    data() {
      return {};
    },
  };
  </script>

  <style lang="scss" scoped>
  .content-wrapper {

  }
  .choose-title {
    font-size: 3.5rem;
    font-family: FreightDispBookItalic;
    font-weight: 300;
    @media (max-width: 767px) {
      font-size: 3rem;
    }
  }
  .choose-subtitle {
    font-size: 24px;
    font-weight: 400;
  }
  .choose-text {
    @media (min-width: 992px) {
        max-width: 750px;
        margin-inline: auto;
    }
  }
  .with-divider {
    @media (min-width: 768px) {
        border-right: 1px solid #ccc;
    }
  }
  </style>